import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import NamedValuesService from '../../../services/NamedValues.service'

export const useAddNamedValue = () => {
  const queryClient = useQueryClient()
  const { org } = useParams()

  return useMutation<any, Error, { body: { name: string; value: string } }>({
    mutationKey: ['add-named-value'],
    mutationFn: (payload) => NamedValuesService.addNamedValue(org!, payload.body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['named-values'] })
    },
  })
}
